import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';


const VisaFilterPanel = ({ filters, onFilterChange, onReset, counts }) => {
  const { t } = useLanguage();

  const statusOptions = [
    { value: 'all', label: t('visas.allStatuses') },
    { value: 'pending', label: t('visas.pending') },
    { value: 'in_review', label: t('visas.underReview') },
    { value: 'approved', label: t('visas.approved') },
    { value: 'rejected', label: t('visas.rejected') },
    { value: 'expired', label: t('visas.expired') },
    { value: 'issued', label: t('visas.issued') }
  ];

  const priorityOptions = [
    { value: 'all', label: t('visas.allPriorities') },
    { value: 'critical', label: t('visas.critical') },
    { value: 'high', label: t('visas.urgent') },
    { value: 'medium', label: t('visas.medium') },
    { value: 'low', label: t('visas.normal') }
  ];

  const expirationOptions = [
    { value: 'all', label: t('visas.allDates') },
    { value: 'expired', label: t('visas.expired') },
    { value: 'expiring_soon', label: t('visas.expiringSoon') },
    { value: 'valid', label: t('visas.valid') }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-warm">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-lg font-semibold text-foreground">{t('visas.advancedFilters')}</h3>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onReset}
        >
          {t('visas.resetFilters')}
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label={t('visas.status')}
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          label={t('visas.urgency')}
          options={priorityOptions}
          value={filters?.priority}
          onChange={(value) => onFilterChange('priority', value)}
        />

        <Select
          label={t('visas.expiration')}
          options={expirationOptions}
          value={filters?.expiration}
          onChange={(value) => onFilterChange('expiration', value)}
        />

        <Input
          label={t('common.search')}
          type="search"
          placeholder={t('visas.searchPilgrim')}
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />
      </div>
      {counts && (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-6 pt-6 border-t border-border">
          <div className="text-center">
            <p className="text-2xl font-bold text-foreground">{counts?.total}</p>
            <p className="caption text-muted-foreground mt-1">{t('visas.total')}</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-warning">{counts?.pending}</p>
            <p className="caption text-muted-foreground mt-1">{t('common.pending')}</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-primary">{counts?.in_review}</p>
            <p className="caption text-muted-foreground mt-1">{t('visas.inReview')}</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-success">{counts?.approved}</p>
            <p className="caption text-muted-foreground mt-1">{t('visas.approved')}</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-destructive">{counts?.rejected}</p>
            <p className="caption text-muted-foreground mt-1">{t('visas.rejected')}</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-muted-foreground">{counts?.expired}</p>
            <p className="caption text-muted-foreground mt-1">{t('visas.expired')}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default VisaFilterPanel;